import { z } from "zod";

// Helpers
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);
const optionalAny = z.any().nullable().optional()
const optionalStr = z.coerce.string().trim().transform(e => e === '' ? null : e);
const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalDecimal = z.coerce.number().nullable().optional(); // Para decimal(18, 2) e float
const optionalDate = z.coerce.date().nullable().optional();
const optionalBoolean = z.boolean().nullable().optional();

export const FuncionarioTercSchema = z.object({
  // --- Identificação ---
  IdFuncionarioTerc: z.number().int().default(0), // PK
  Nome: z.string({ required_error: "Nome é obrigatório" }).min(1, "Nome é obrigatório").max(250, "Máximo de 250 caracteres"), 
  Cpf: optionalStr,
  Rg: optionalString.pipe(z.string().max(50).nullable().optional()),
  RgUf: optionalString.pipe(z.string().max(150).nullable().optional()),
  OrgExp: optionalString.pipe(z.string().max(50).nullable().optional()),
  DataEmissao: optionalDate, // Data Emissão RG
  Sexo: optionalString.pipe(z.string().max(50).nullable().optional()),
  LocalNascimento: optionalString.pipe(z.string().max(50).nullable().optional()),
  Nacionalidade: optionalString.pipe(z.string().max(150).nullable().optional()),
  Naturalidade: optionalString.pipe(z.string().max(150).nullable().optional()),
  EstadoCivil: optionalString.pipe(z.string().max(150).nullable().optional()), 
  Estado: optionalString.pipe(z.string().max(150).nullable().optional()), 
  NomePai: optionalString.pipe(z.string().max(250).nullable().optional()),
  NomeMae: optionalString.pipe(z.string().max(250).nullable().optional()),
  DataNascimento: z.coerce.date().nullable().default(null),

  // --- Contato e Endereço ---
  Email: optionalString.pipe(z.string().email("E-mail inválido").max(250).nullable().optional()),
  TelFixo: optionalString.pipe(z.string().max(50).nullable().optional()),
  TelCelular: optionalString.pipe(z.string().max(50).nullable().optional()),
  IdEndereco: optionalNumber,

  // --- Contratual / Profissional ---
  Ativo: optionalNumber,
  IdCentroCusto: optionalNumber,
  IdFornecedor: optionalNumber,
  IdCargo: optionalNumber,
  DataAdmissao: optionalDate,
  DataDemissao: optionalDate,
  DataInicio: optionalDate, 
  DataTermino: optionalDate, 
  Salario: optionalDecimal,
  Periodo: optionalString.pipe(z.string().max(250).nullable().optional()),
  HorarioTrabalho: optionalString.pipe(z.string().max(50).nullable().optional()),
  HorarioAlmoco: optionalString.pipe(z.string().max(50).nullable().optional()),
  TempoExperiencia: optionalNumber,
  Experiencia: optionalNumber,  
  Situacao: optionalNumber, 
  IdMotivoDemissao: optionalNumber,
  ProrrogarEm: optionalNumber, 
  NrNumeroFuncionario: optionalNumber, 

  // --- Documentação Extra ---
  Ctps: optionalString.pipe(z.string().max(150).nullable().optional()),
  Serie: optionalString.pipe(z.string().max(150).nullable().optional()),
  CtpsUf: optionalString.pipe(z.string().max(150).nullable().optional()),
  DataExpedicao: optionalDate, 
  TituloEleitor: optionalString.pipe(z.string().max(150).nullable().optional()),
  Zona: optionalString.pipe(z.string().max(150).nullable().optional()),
  Pis: optionalString.pipe(z.string().max(150).nullable().optional()),
  Reservista: optionalString.pipe(z.string().max(150).nullable().optional()),
  
  // --- Dados Bancários ---
  NomeBanco: optionalString.pipe(z.string().max(250).nullable().optional()),
  TipoConta: optionalNumber, 
  NrConta: optionalString.pipe(z.string().max(250).nullable().optional()),
  Digito: optionalString.pipe(z.string().max(250).nullable().optional()), 
  Agencia: optionalString.pipe(z.string().max(250).nullable().optional()),
  Operacao: optionalString.pipe(z.string().max(250).nullable().optional()),

  // --- Uniforme / EPI ---
  Camisa: optionalString.pipe(z.string().max(250).nullable().optional()),
  Calca: optionalString.pipe(z.string().max(250).nullable().optional()),
  Calcado: optionalString.pipe(z.string().max(250).nullable().optional()),

  // --- Outros ---
  Observacoes: optionalString, 
  AnotacoesGerais: optionalString.pipe(z.string().max(1000).nullable().optional()),
  AnotacoesDocumentos: optionalString, 
  Imagem: optionalAny, // Campo image no banco, geralmente vem como Base64 String ou URL
  ExtensaoFoto: optionalString.pipe(z.string().max(50).nullable().optional()),
  DescontoSindical: optionalNumber, 
  StatusAso: optionalNumber,
  
});

export type FuncionarioTercForm = z.infer<typeof FuncionarioTercSchema>;